import React, {useContext, useEffect, useState} from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import Markup from '../../../../markup';
import BuilderContext from '../../../../builder/hooks/context';
import {useMediaQuery} from "react-responsive";
import {device} from "../../../../const/device";
import {searchByString} from "../../../../utils/Search";
import debounce from "lodash/debounce";
import { trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';

type LogosFlagType = {
    onModalClose?:VoidFunction,
    modelSide?:string
}

function LogosFlag({onModalClose = () => {}, modelSide}:LogosFlagType) {
  const { builder } = useContext(BuilderContext);
  const { params } = useRouteMatch<{ side: string }>();
  const history = useHistory();
  const isTablet = useMediaQuery({ query: `(${device.tablet})` });
  const tabletS = useMediaQuery({ query: `(${device.tabletS})` });
  const [flagList, setFlagList] = useState(builder.modelData.flags);
  const currentFlag = builder.imagesData.sponsorFlag[params?.side]?.id;
  const [searchValue, setSearchValue] = useState("");


  useEffect(() => {
    trackSubStage('Logos', 'Flag');
    trackBeforeUnload('Flag');
  }, []);

  const onSubmitFlag = () => {
      history.goBack();
      isTablet && onModalClose();
  }

  const onSearch = (e) => {
      let result = {}
      setSearchValue(e.target.value);
      let searchString = (e.target.value).trim();
          if (searchString) {
              if(~searchString.search(/^[A-Za-z-\s]{0,100}$/)) {
                  for (let flag in builder.modelData.flags) {
                      if(searchByString(flag, searchString)) result[flag] = builder.modelData.flags[flag];
                  }
                  setFlagList(result);
              }
          } else setFlagList(builder.modelData.flags);
  }

  const FlagItems = () => {
      let result = [];
      for(let flag in flagList){
          result.push(
              <Markup.Screen.Flag.Item
                  key={flagList[flag]}
                  active={flagList[flag] === currentFlag}
                  flag={flagList[flag]}
                  onClick={() => builder.imagesData.updateFlag(modelSide ?? params.side, { id: flagList[flag], enabled: true })}
              />
          )
      }
      return result;
  }

  return (
    <>
      <Markup.Screen.Flag.Header>
          {isTablet || tabletS ? <Markup.Screen.Flag.TitleContainer children='Choose flag' themeColor={'white'} />:
              <Markup.Screen.Flag.TitleContainer children='Choose flag' themeColor={builder.membersData.colorTheme}/>}
        <Markup.Screen.Flag.IconContainer>
          <Markup.Global.Button.ButtonIconLeftArrow onClick={onSubmitFlag} />
          <Markup.Global.Button.ButtonIconSubmit disabled={currentFlag === null} onClick={onSubmitFlag} />
        </Markup.Screen.Flag.IconContainer>
      </Markup.Screen.Flag.Header>

        <Markup.Global.Input.SearchItem defaultValue={searchValue} placeholder="Search flags" onChange={debounce(onSearch,150)} themeColor={builder.membersData.colorTheme}/>

      <Markup.Screen.Flag.List>
        {FlagItems()}
      </Markup.Screen.Flag.List>
    </>
  );
}

export default React.memo(LogosFlag);
